import { _, cloneDeep, result } from "lodash";
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAllusers } from "../../actions/manageUser";
import { Loader, ModalLoader } from "../Utils/Loader";
import { services } from "../../api";
import { ToastComponent } from "../Utils/Toast";

const ManageUsers = () => {
  const [allUsers, setAllUsers] = useState([]);
  const [suggestionUser, setSuggestionUser] = useState([]);
  const [isShowSuggesstion, setIsShowSuggesstion] = useState(false);
  const [pageData, setPageData] = useState({
    totalpage: "",
    currentPage: 1,
    numberOfItems: 15,
  });
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editData, setEditData] = useState({});
  const [roles, setRoles] = useState([]);
  const [getActiveOption, setActiveOption] = useState(0);

  const dispatch = useDispatch();
  const getAllUsersData = useSelector((state) => state.manageUserReducers);
  const userData = useSelector((state) => state.usersReducers);
  const [rolesArrByUserSpecific, setRolesArrByUserSpecific] = useState([]);
  const [isShowModalLoader, setIsShowModalLoader] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const { loader, modalLoader } = useSelector((state) => state.HeaderReducer);
  const [typedText, setTypedText] = useState("");

  useEffect(() => {
    dispatch(getAllusers({ roleID: userData.roleID }));

    document.addEventListener("mousedown", handleClick);
    // return function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  useEffect(() => {
    if (getAllUsersData.users.length > 0) {
      let pageDataTemp = JSON.parse(JSON.stringify(pageData));
      pageDataTemp.totalpage = Math.ceil(
        getAllUsersData.users.length / pageDataTemp.numberOfItems
      );

      let rolesTemp = getAllUsersData.roles.filter(
        (el) => el.id < userData.roleID
      );
      setRolesArrByUserSpecific(rolesTemp);
      setRoles(getAllUsersData.roles);
      setPageData(pageDataTemp);
      setAllUsers(getAllUsersData.users);
      setSuggestionUser(getAllUsersData.users);
    }
  }, [getAllUsersData]);

  const onSelectPageHandler = (e) => {
    let pageDataTemp = JSON.parse(JSON.stringify(pageData));
    if (e.target.value <= pageDataTemp.totalpage) {
      pageDataTemp.currentPage = e.target.value ? parseInt(e.target.value) : "";
    } else {
      pageDataTemp.currentPage = 4;
    }
    setPageData(pageDataTemp);
  };

  const nextPrevChangeHandler = (key) => {
    let pageDataTemp = JSON.parse(JSON.stringify(pageData));
    if (key == "next") {
      pageDataTemp.currentPage = pageDataTemp.currentPage + 1;
    } else {
      pageDataTemp.currentPage = pageDataTemp.currentPage - 1;
    }

    setPageData(pageDataTemp);
  };

  const lastFirstpageHandler = (type) => {
    let pageDataTemp = JSON.parse(JSON.stringify(pageData));
    if (type == "last") {
      pageDataTemp.currentPage = pageDataTemp.totalpage;
    } else {
      pageDataTemp.currentPage = 1;
    }
    setPageData(pageDataTemp);
  };

  const showSuggesstionHandler = () => {
    setIsShowSuggesstion(!isShowSuggesstion);
    setActiveOption(0);
    setTypedText(searchText);
  };

  const searchUserHandler = ({ currentTarget }) => {
    //let suggestionUserTemp = cloneDeep(allUsers);
    setSearchText(currentTarget.value);
    setTypedText(currentTarget.value);
    // suggestionUserTemp = suggestionUserTemp.filter((el) =>
    //   el.name.toLowerCase().includes(currentTarget.value.toLowerCase())
    // );
    // setSuggestionUser(suggestionUserTemp);
  };

  const openEditModal = (user) => {
    setEditData(user);
    setIsEditModalOpen(true);
    setSearchText("");
    setSuggestionUser(allUsers);
    setIsShowSuggesstion(false);
  };

  const noderef = useRef(null);

  const handleClick = (e) => {
    if (
      e.target.name === "searchStation" ||
      (noderef && noderef.current && noderef.current.contains(e.target))
    ) {
      return;
    }
    setIsShowSuggesstion(false);
  };

  const editDataChangeHandler = ({ currentTarget }) => {
    let editDataTemp = cloneDeep(editData);
    if (
      currentTarget.id == "isCF" ||
      currentTarget.id == "isCT" ||
      currentTarget.id == "isCS"
    ) {
      editDataTemp[currentTarget.id] = currentTarget.checked ? 1 : 0;
    } else if (currentTarget.id == "roleID") {
      editDataTemp[currentTarget.id] = parseInt(currentTarget.value);
    } else {
      editDataTemp[currentTarget.id] = currentTarget.value;
    }

    setEditData(editDataTemp);
  };

  const onSubmitEditRole = async (e) => {
    e.preventDefault();
    setIsShowModalLoader(true);
    let payloadObj = {
      isCF: editData.isCF,
      isCT: editData.isCT,
      isCS: editData.isCS,
      modifiedby: userData.userID,
      roleid: editData.roleID,
    };

    let res = await services.ServiceMethod(
      `usermanagement?userid=${editData.id}`,
      "put",
      payloadObj
    );
    if (res) {
      dispatch(getAllusers({ roleID: userData.roleID }));
      setIsShowModalLoader(false);
      setIsEditModalOpen(false);
    }
  };

  const isDisabledSaveButton = () => {
    let isDisableSaveButton = false;
    let findOriginalUserObj = allUsers.find((el) => el.id === editData.id);
    if (JSON.stringify(findOriginalUserObj) === JSON.stringify(editData)) {
      isDisableSaveButton = true;
    }
    return isDisableSaveButton;
  };

  const handleScroll = (value) => {
    let ul = document.getElementById("search-list");
    if (ul?.children?.length) {
      var elHeight = ul?.children?.[0]?.offsetHeight;
      var scrollTop = ul?.scrollTop;
      var viewport = scrollTop + ul?.offsetHeight;
      var elOffset = elHeight * value;
      if (elOffset < scrollTop || elOffset + elHeight > viewport) {
        ul.scrollTop = elOffset - elHeight * 7;
      }
    }
  };
  useEffect(() => {
    const results = allUsers.filter((item) =>
      item.name.toLowerCase().includes(typedText.toLowerCase())
    );
    setSuggestionUser(results);
    if (results?.length) {
      setActiveOption(0);
      handleScroll(0);
    }
  }, [typedText]);

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      let selectedUser = suggestionUser[getActiveOption];
      if (selectedUser) {
        openEditModal(selectedUser);
      }
    } else if (e.keyCode === 38) {
      if (getActiveOption === 0) {
        return;
      }
      handleScroll(getActiveOption - 1);
      setActiveOption(getActiveOption - 1);
      setSearchText(suggestionUser[getActiveOption - 1]["name"]);
    } else if (e.keyCode === 40) {
      if (getActiveOption < suggestionUser?.length - 1) {
        handleScroll(getActiveOption + 1);
        setActiveOption(getActiveOption + 1);
        setSearchText(suggestionUser[getActiveOption + 1]["name"]);
      }
    }
  };

  if (loader) {
    return <Loader />;
  }
  if (
    userData.isAuthorized &&
    (userData.roleID === 3 || userData.roleID === 4 || userData.roleID === 5)
  ) {
    return (
      <>
        <h4 className="user-mgmt-title">Manage User</h4>
        <div className="user-mgt-section">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-4 col-xs-12">
              <div className="dropdown station-dropdown">
                <input
                  className="form-control"
                  placeholder={"Search users...."}
                  autoComplete="off"
                  name="searchStation"
                  // onBlur={(e) => setIsShowSuggesstion(false)}
                  onClick={showSuggesstionHandler}
                  onChange={searchUserHandler}
                  onKeyDown={onKeyDown}
                  value={searchText}
                />
                {isShowSuggesstion && (
                  <ul
                    id="search-list"
                    ref={noderef}
                    className={`dropdown-content show`}
                  >
                    {suggestionUser.length ? (
                      suggestionUser.map((user, key) => {
                        return (
                          <li
                            className={`list-group-item  ${
                              key === getActiveOption ? "active" : ""
                            }`}
                            key={key}
                            onClick={(e) => {
                              openEditModal(user);
                              e.stopPropagation();
                            }}
                            // onMouseOver={() => setPersistShowList(true)}
                            // onMouseLeave={() =>
                            //   setPersistShowList(false)
                            // }
                          >
                            {user.name}
                          </li>
                        );
                      })
                    ) : (
                      <li className="list-group-item ">
                        No results matched "{searchText}"
                      </li>
                    )}

                    {/* {isShowSuggesstion &&
                  suggestionUser?.map((user, index) => (
                    <a
                      key={index}
                      className={index === getActiveOption ? "active" : ""}
                      onClick={() => openEditModal(user)}
                    >
                      {user.name}
                    </a>
                  ))} */}
                  </ul>
                )}
              </div>
            </div>

            <div className="col-sm-12">
              <div className="user-table-section">
                <table
                  id="myTable"
                  className="display dataTable dtr-inline table electronics-table no-footer"
                  cellSpacing="0"
                  width="100%"
                  role="grid"
                  style={{ width: "100%", marginTop: "10px" }}
                  aria-describedby="myTable_info"
                >
                  <thead>
                    <tr>
                      <th name="name" id="name">
                        Name
                      </th>
                      <th name="date-time" id="date-time">
                        User ID
                      </th>
                      <th name="download" id="download">
                        Is Active
                      </th>
                      <th name="move" id="move">
                        Edit
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {allUsers
                      .slice(
                        pageData.currentPage == 0
                          ? 0
                          : (pageData.currentPage - 1) * 15,
                        pageData.currentPage * pageData.numberOfItems
                      )
                      ?.map((user, index) => (
                        <tr className="user-mgt-row" key={index}>
                          <td className="file_name">{user.name}</td>
                          <td>{user.userID}</td>
                          <td className="checkbox">
                            <label className="checkbox-label">
                              <input
                                type="checkbox"
                                checked={user.isActive == 1 ? "checked" : ""}
                                className="user-active"
                                readOnly
                              />
                              <span className="checkbox-custom rectangular"></span>
                            </label>
                          </td>
                          <td>
                            <span onClick={() => openEditModal(user)}>
                              <i
                                className="fa fa-pencil pencil-cion"
                                aria-hidden="true"
                              ></i>
                            </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              <div className="pagination">
                <>
                  <button
                    className="btn btn-primary pagerPrev disabled-link"
                    onClick={() => lastFirstpageHandler("first")}
                    disabled={pageData.currentPage === 1}
                  ></button>
                  <button
                    className="btn btn-primary firstI disabled-link"
                    onClick={() => nextPrevChangeHandler("prev")}
                    disabled={pageData.currentPage === 1}
                  ></button>
                  <span className="pagination-number">
                    Page
                    <strong>
                      <input
                        className="pagination-page"
                        type="number"
                        value={pageData.currentPage}
                        onChange={onSelectPageHandler}
                      />
                      of {pageData.totalpage}
                    </strong>
                  </span>
                  <button
                    className="btn btn-primary lastI disabled-link"
                    disabled={pageData.currentPage === pageData.totalpage}
                    onClick={() => nextPrevChangeHandler("next")}
                  ></button>
                  <button
                    className="btn btn-primary pagerNext disabled-link"
                    onClick={() => lastFirstpageHandler("last")}
                    disabled={pageData.currentPage === pageData.totalpage}
                  ></button>
                </>
              </div>
            </div>
          </div>
        </div>

        {isEditModalOpen && (
          <div
            className="modal d-block modal-background"
            id="detailModal"
            tabIndex="-1"
            aria-labelledby="detailModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="detailModalLabel">
                    Edit User
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setIsEditModalOpen(false)}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body p-b-30 pt-0">
                  {successMsg && (
                    <ToastComponent
                      message={successMsg}
                      bgColor={"#008000a3"}
                    />
                  )}
                  {isShowModalLoader ? (
                    <ModalLoader />
                  ) : (
                    <>
                      <form onSubmit={(e) => onSubmitEditRole(e)}>
                        <div className="form-group mb-3">
                          <label
                            htmlFor="exampleInputEmail1"
                            className="fginputlable"
                          >
                            User Name <span className="mandatory">*</span>
                          </label>
                          <input
                            className="form-control fginputinput"
                            value={editData.name}
                            disabled
                            id="name"
                          />
                        </div>

                        <div className="form-group mb-3">
                          <label
                            htmlFor="exampleInputEmail1"
                            className="fginputlable"
                          >
                            Email Id <span className="mandatory">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control fginputinput"
                            disabled
                            value={editData.userID}
                          />
                        </div>

                        <div className="form-group mb-4 edit-dropdown">
                          <label
                            htmlFor="exampleFormControlSelect1"
                            className="fginputlable"
                          >
                            Select Role
                          </label>
                          <select
                            className="form-control fginputinput"
                            id="roleID"
                            value={editData.roleID}
                            onChange={editDataChangeHandler}
                          >
                            {rolesArrByUserSpecific.map((role, index) => (
                              <option key={index} value={role.id}>
                                {role.name}
                              </option>
                            ))}
                          </select>
                          {/* <i className="fa fa-caret-down fgdropdownicon"></i> */}
                        </div>

                        {editData.roleID !== 2 && (
                          <div className="row form-group mb-4 fgeditform">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="isCF"
                                  checked={editData.isCF === 1}
                                  onChange={editDataChangeHandler}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="inlineCheckbox2"
                                >
                                  Customer Station Fault
                                </label>
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="isCT"
                                  checked={editData.isCT === 1}
                                  onChange={editDataChangeHandler}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="inlineCheckbox2"
                                >
                                  Customer Train Fault
                                </label>
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="isCS"
                                  checked={editData.isCS === 1}
                                  onChange={editDataChangeHandler}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="inlineCheckbox2"
                                >
                                  Customer Suggestions
                                </label>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-4">
                          <div className="form-group fgeditform">
                            <div className="form-check form-check-inline">
                              <input
                                className={`form-check-input ${
                                  editData.isActive !== 1
                                    ? "status-disabled"
                                    : "cursor_notAllow"
                                }`}
                                type="checkbox"
                                checked={editData.isActive === 1}
                                id="isActive"
                                readOnly
                              />
                              <label
                                className="form-check-label"
                                htmlFor="inlineCheckbox1"
                              >
                                Status
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group mb-3 edit-form-toc">
                          <label
                            htmlFor="exampleInputEmail1"
                            className="fgtoclabel"
                          >
                            TOC <span className="mandatory">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder="Enter email"
                            value="FTPE"
                            readOnly
                          />
                        </div>
                      </form>
                      <div className="modal-footer border-0">
                        <button
                          type="submit"
                          className="btn btn-primary modal-blue-btn"
                          onClick={(e) => onSubmitEditRole(e)}
                          disabled={isDisabledSaveButton()}
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          className="btn btn-light modal-white-btn"
                          onClick={() => setIsEditModalOpen(false)}
                        >
                          Cancel
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
  return <div className="not-page">User Not Authorized</div>;
};

export default ManageUsers;
